/**
 * Takes a parent element and matches the height
 * of rows of all tables that are children of the parent
 * element
 *
 * @export
 * @param {HTMLElement} parentElement
 */
export default function domMatchTableHeights(parentElement) {
    // Gets all table nodes within the `parentElment`
    let tableNode = Array.from(parentElement.querySelectorAll('table'))
    // Gets an array or arrays of heights of each row in the tables
    const tableRowHeights = tableNode.map(table => Array.from(table.querySelectorAll('tr')).map(trow => getComputedStyle(trow, null).height))
    // Finds the common max height accross arrays of rows
    const matchedTableRowHeights = tableRowHeights.reduce((accum, tableRows) => {
        return accum.map((height, index) => Number(tableRows[index].replace('px',0)) > Number(height.replace('px',0)) ? tableRows[index] : height)
    }, tableRowHeights[0])
    // Sets row heights for all rows
    tableNode.forEach(table => Array.from(table.querySelectorAll('tr')).forEach((trow, index) => trow.style.height = matchedTableRowHeights[index]))
}
